import React, { useState } from 'react';
import { FileText, ImageIcon, Info, RefreshCw, Settings, SlidersHorizontal, X } from 'lucide-react';
import { indicatorDict, mockStudents, sumObj } from '../data/mockData';

// 综合测评成绩结果页公共内容
// 用于“综合测评成绩查询”和“学生综合测评汇总”，两页筛选项、统计提示和表格字段一致，仅表格上方按钮不同。
export default function AssessmentScoreResultContent({ mode }) {
  // ================= 页面状态 =================
  const [detailStudent, setDetailStudent] = useState(null);

  // ================= 表格数据 =================
  const scoreList = [
    {
      id: 1,
      name: '陈红',
      studentId: '2102001',
      academicYear: '2025-2026',
      semester: '第一学期',
      batch: '2025秋季综合测评批次',
      participateStatus: '是',
      totalScoreStatus: '已计算',
      schemeScore: '86.50',
      studyWeightedScore: '88.20',
      totalScore: '87.35',
      classRank: 3,
      gradeRank: 16,
    },
    {
      id: 2,
      name: '林峰',
      studentId: '2102002',
      academicYear: '2025-2026',
      semester: '第一学期',
      batch: '2025秋季综合测评批次',
      participateStatus: '是',
      totalScoreStatus: '未计算',
      schemeScore: '82.00',
      studyWeightedScore: '-',
      totalScore: '-',
      classRank: '-',
      gradeRank: '-',
    },
  ];

  const isSummaryMode = mode === 'summary';

  return (
    <div className="animate-fade-in space-y-4">
      {/* 条件筛选卡片：按批次、学生类别、班级、年级和学生信息查询 */}
      <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
        <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-x-8 gap-y-5">
          <FilterSelect label="测评批次" />
          <FilterSelect label="学生类别" />
          <FilterSelect label="学院/专业/班级" />
          <FilterSelect label="年级" />
          <FilterSelect label="是否参与综合测评" />
          <FilterSelect label="是否已计算总成绩" />
          <FilterInput label="学号" placeholder="请输入学号" />
          <FilterInput label="姓名" placeholder="请输入姓名" />
        </div>

        {/* 查询按钮区 */}
        <div className="flex justify-end gap-3 mt-6">
          <button className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50">
            重置
          </button>
          <button className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]">
            查询
          </button>
        </div>
      </div>

      {/* 结果卡片：综合测评成绩列表 */}
      <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
        {/* 表格上方按钮区 */}
        <div className="flex justify-between items-center mb-3">
          <div className="flex gap-3">
            {isSummaryMode && (
              <button className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]">
                计算综合测评总成绩
              </button>
            )}
            <button className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50">
              导出
            </button>
          </div>

          <TableToolbar />
        </div>

        {/* 表格上方提示信息：展示当前查询范围内的计算进度 */}
        <div className="mb-4 px-3 py-3 bg-[#eaf4ff] border border-[#d3e8ff] rounded text-sm text-[#1677ff] leading-6">
          测评学年：2025-2026；测评学期：第一学期；学生人数：35人；参评人数：33人；已计算总成绩人数：28人；尚未计算总成绩人数：5人；最后一次计算时间：2026-05-09 14:18。
        </div>

        {/* 综合测评成绩表格 */}
        <div className="overflow-x-auto border border-gray-200 rounded">
          <table className="w-full text-left border-collapse text-[13px] text-gray-700 whitespace-nowrap min-w-max">
            <thead>
              <tr className="bg-[#fafafa] border-b border-gray-200">
                <TableHead>序号</TableHead>
                <TableHead>姓名</TableHead>
                <TableHead>学年</TableHead>
                <TableHead>学期</TableHead>
                <TableHead>批次</TableHead>
                <TableHead>是否参与测评</TableHead>
                <TableHead>是否已计算总成绩</TableHead>
                <TableHead>综合测评方案分</TableHead>
                <TableHead>学习加权分</TableHead>
                <TableHead>综合测评总分</TableHead>
                <TableHead>综合测评总分班级排名</TableHead>
                <TableHead>综合测评总分年级排名</TableHead>
                <th className="py-3 px-4 font-medium text-gray-800 sticky right-0 bg-[#fafafa] z-10 border-l border-gray-200">
                  操作
                </th>
              </tr>
            </thead>
            <tbody>
              {scoreList.map((row, index) => (
                <tr
                  key={row.id}
                  className="border-b border-gray-100 hover:bg-[#f8f9fa] group"
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.academicYear}</TableCell>
                  <TableCell>{row.semester}</TableCell>
                  <TableCell>{row.batch}</TableCell>
                  <TableCell>{row.participateStatus}</TableCell>
                  <TableCell>{row.totalScoreStatus}</TableCell>
                  <TableCell>{row.schemeScore}</TableCell>
                  <TableCell>{row.studyWeightedScore}</TableCell>
                  <TableCell>
                    <span className="font-bold text-[#1890ff]">
                      {row.totalScore}
                    </span>
                  </TableCell>
                  <TableCell>{row.classRank}</TableCell>
                  <TableCell>{row.gradeRank}</TableCell>
                  <td className="py-3 px-4 sticky right-0 bg-white group-hover:bg-[#f8f9fa] z-10 border-l border-gray-100">
                    <button
                      onClick={() => setDetailStudent(row)}
                      className="text-[#1890ff] hover:underline"
                    >
                      详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 右侧抽屉：综合测评成绩详情 */}
      {detailStudent && (
        <AssessmentScoreDetailDrawer
          student={detailStudent}
          onClose={() => setDetailStudent(null)}
        />
      )}
    </div>
  );
}

// 综合测评成绩详情抽屉
function AssessmentScoreDetailDrawer({ student, onClose }) {
  const matchedStudent = mockStudents.find(item => item.studentId === student.studentId) || mockStudents[0];
  const peerScore = Number(matchedStudent.peerScore || 0);
  const teacherScore = Number(matchedStudent.teacherScore || 0);
  const mandatoryScoreTotal = sumObj(matchedStudent.mandatoryScore);
  const bonusScoreTotal = sumObj(matchedStudent.bonusScore);
  const deductionScore = Math.abs(Number(matchedStudent.deduction || 0));
  const indicatorTotal = mandatoryScoreTotal + bonusScoreTotal - deductionScore;
  const schemeOriginalScore = peerScore + teacherScore + indicatorTotal;
  const studyOriginalScore = Number(matchedStudent.studyScore || 0);
  const studyWeightedScore = studyOriginalScore * 0.8;
  const schemeWeightedScore = schemeOriginalScore * 0.2;
  const finalTotalScore = studyWeightedScore + schemeWeightedScore;

  return (
    <div className="fixed inset-0 z-[60] flex justify-end transition-opacity duration-300 bg-black/40 opacity-100 visible">
      <div className="absolute inset-0" onClick={onClose} />
      <div className="relative w-[96vw] max-w-[1550px] bg-[#f5f7fa] h-full shadow-[-10px_0_30px_rgba(0,0,0,0.15)] flex flex-col transform transition-transform duration-300 ease-out translate-x-0">
        {/* 抽屉标题栏 */}
        <div className="h-[60px] px-6 border-b border-gray-200 flex justify-between items-center bg-white shrink-0 z-20">
          <h2 className="text-[17px] font-bold text-gray-800 flex items-center">
            <div className="w-1 h-4 bg-[#1890ff] rounded-sm mr-2" />
            学生综测得分详情 - {student.name}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full text-gray-400 hover:text-gray-600"
          >
            <X size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {/* 学生基础信息卡片 */}
          <div className="bg-white p-5 rounded-sm border border-gray-200 shadow-sm">
            <DetailSectionTitle title="学生基础信息" />

            <div className="grid grid-cols-4 gap-y-3 text-[13px] text-gray-600 pl-2 mt-4">
              <InfoItem label="姓名" value={matchedStudent.name} />
              <InfoItem label="学号" value={matchedStudent.studentId} />
              <InfoItem label="学院/专业" value={`${matchedStudent.college} - ${matchedStudent.major}`} />
              <InfoItem label="年级/班级" value={`${matchedStudent.grade} - ${matchedStudent.className}`} />
            </div>
          </div>

          {/* 本学期成绩汇总卡片 */}
          <div className="bg-white p-5 rounded-sm border border-gray-200 shadow-sm">
            <DetailSectionTitle title="本学期成绩汇总" />

            <div className="bg-blue-50 border border-blue-100 p-3 rounded mb-4 text-[12px] text-blue-700 flex items-start">
              <Info size={14} className="mr-1.5 shrink-0 mt-0.5" />
              <span>
                注：最终总评成绩 = 学习加权成绩(80%) + 综合测评方案分(20%)。展示结果为折合加权后的得分。
              </span>
            </div>

            <div className="grid grid-cols-5 gap-x-6 text-[13px] text-gray-600 pl-2 items-center">
              <InfoItem label="学习加权分" value={`${studyWeightedScore.toFixed(2)}（原始分 ${studyOriginalScore.toFixed(2)}）`} />
              <InfoItem label="综合测评方案分" value={`${schemeWeightedScore.toFixed(2)}（原始分 ${schemeOriginalScore.toFixed(2)}）`} />
              <InfoItem label="总成绩班级排名" value={student.classRank} />
              <InfoItem label="总成绩专业排名" value={student.gradeRank} />
              <InfoItem
                label="最终总评成绩"
                value={(
                  <span className="font-bold text-[#1890ff]">
                    {finalTotalScore.toFixed(2)}
                  </span>
                )}
              />
            </div>
          </div>

          {/* 综合测评方案分明细卡片 */}
          <div className="bg-white p-5 rounded-sm border border-gray-200 shadow-sm">
            <DetailSectionTitle title="综合测评方案分 (满分: 100)" />

            <div className="mb-6 mt-4">
              <div className="font-bold text-gray-800 text-[14px] mb-3">
                一、综合测评评价分
              </div>
              <div className="text-gray-600 text-[13px] pl-2 mb-3">
                (满分: 10分)
              </div>

              <div className="flex items-center gap-16 text-[13px] text-gray-600 pl-2">
                <div>
                  <span className="text-gray-500 w-28 inline-block whitespace-nowrap">学生互评分：</span>
                  <span className="font-bold text-gray-800">{peerScore.toFixed(2)}</span> 分
                </div>
                <div>
                  <span className="text-gray-500 w-32 inline-block whitespace-nowrap">辅导员评议分：</span>
                  <span className="font-bold text-gray-800">{teacherScore ? teacherScore.toFixed(2) : '-'}</span> 分
                </div>
              </div>
            </div>

            <div>
              <div className="font-bold text-gray-800 text-[14px] mb-3">
                二、综合测评指标分明细 (满分: 90)
              </div>

              <SummaryIndicatorScoreTable student={matchedStudent} />
            </div>

            <div className="mt-6">
              <div className="font-bold text-gray-800 text-[14px] mb-3">
                三、负面事项扣分
              </div>

              <SummaryNegativeDeductionCard student={matchedStudent} />
            </div>

            <div className="mt-5 pt-4 border-t border-gray-100 flex justify-end items-center text-[14px]">
              <span className="text-gray-600 font-bold mr-4">
                综合测评方案分原始合计：
              </span>
              <span className="text-[20px] font-bold text-[#1890ff]">
                {schemeOriginalScore.toFixed(2)}
              </span>
            </div>
          </div>

          <div className="h-2" />
        </div>
      </div>
    </div>
  );
}

// 详情卡片小标题
function DetailSectionTitle({ title }) {
  return (
    <h3 className="font-bold text-gray-800 text-[14px] mb-4 flex items-center">
      <div className="w-1 h-3 bg-[#1890ff] mr-2" />
      {title}
    </h3>
  );
}

// 学生综合测评汇总详情中的指标分明细表
function SummaryIndicatorScoreTable({ student }) {
  let indicatorTotal = 0;

  return (
    <div className="overflow-hidden w-full border border-gray-300 rounded-sm shadow-sm bg-white">
      <table className="w-full text-left text-[12px] border-collapse table-fixed min-w-full">
        <colgroup>
          <col style={{ width: '8%' }} />
          <col style={{ width: '13%' }} />
          <col style={{ width: '5%' }} />
          <col style={{ width: '8%' }} />
          <col style={{ width: '22%' }} />
          <col style={{ width: '4%' }} />
          <col style={{ width: '4%' }} />
          <col style={{ width: '4%' }} />
          <col style={{ width: '4%' }} />
          <col style={{ width: '4%' }} />
          <col style={{ width: '4%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '4%' }} />
          <col style={{ width: '5%' }} />
        </colgroup>
        <thead className="bg-[#f0f2f5] border-b border-gray-300 text-gray-700">
          <tr>
            <th rowSpan={2} className="border-r border-gray-300 px-1 py-2 font-bold text-center align-middle">
              考核大类
            </th>
            <th colSpan={2} className="border-r border-gray-300 px-2 py-2 font-bold text-center">
              必选项
            </th>
            <th colSpan={10} className="border-r border-gray-300 px-2 py-2 font-bold text-center">
              加分项
            </th>
            <th rowSpan={2} className="px-1 py-2 font-bold text-center align-middle text-[#1890ff] leading-tight break-words">
              该项<br />总得分
            </th>
          </tr>
          <tr>
            <th className="border-r border-t border-gray-300 px-3 py-2 font-bold text-center">
              必选项说明
            </th>
            <th className="border-r border-t border-gray-300 px-1 py-2 font-bold text-center leading-tight break-words">
              必选项得分<br />/评分
            </th>
            <th className="border-r border-t border-gray-300 px-2 py-2 font-bold text-center">
              一级指标
            </th>
            <th className="border-r border-t border-gray-300 px-2 py-2 font-bold text-center">
              二级指标
            </th>
            <th className="border-r border-t border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight break-words">
              需要<br />材料
            </th>
            <th className="border-r border-t border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight break-words">
              指标<br />得分
            </th>
            <th className="border-r border-t border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight break-words">
              次数<br />限制
            </th>
            <th className="border-r border-t border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight break-words">
              分数<br />限制
            </th>
            <th className="border-r border-t border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight break-words">
              是否<br />参评
            </th>
            <th className="border-r border-t border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight break-words">
              参评<br />个数
            </th>
            <th className="border-r border-t border-gray-300 px-2 py-2 font-bold text-center">
              附件或其他内容
            </th>
            <th className="border-r border-t border-gray-300 px-1 py-2 font-bold text-center leading-tight">
              加分项得分<br />汇总
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(indicatorDict).map(([catId, indicator]) => {
            const rows = buildIndicatorRows(indicator);
            const mandatoryScore = Number(student.mandatoryScore[catId] || 0);
            const bonusScore = Number(student.bonusScore[catId] || 0);
            const categoryTotal = mandatoryScore + bonusScore;
            indicatorTotal += categoryTotal;

            return (
              <React.Fragment key={catId}>
                {rows.map((row, index) => {
                  const isFirstOverall = index === 0;
                  const matchedStudentItem = getPassedBonusData(student, catId, row.secondIndicator);

                  return (
                    <tr
                      key={`${catId}-${row.firstIndicator}-${row.secondIndicator}`}
                      className="border-b border-gray-300 bg-white hover:bg-gray-50 transition-colors"
                    >
                      {isFirstOverall && (
                        <td rowSpan={rows.length} className="border-r border-gray-300 text-center font-bold text-gray-700 bg-[#fafafa]">
                          {indicator.title}
                          <br />
                          <span className="text-gray-500 font-normal text-[11px] leading-5 inline-block px-1">
                            （总分满分{indicator.totalMax}分，必选项满分{indicator.manMax}分，加分项满分{indicator.bonMax}分）
                          </span>
                        </td>
                      )}

                      {isFirstOverall && (
                        <td rowSpan={rows.length} className="border-r border-gray-300 px-3 py-3 align-middle bg-[#fafafa]/40 text-center">
                          <div className="text-gray-600 text-[11px] whitespace-pre-wrap leading-relaxed pr-1 break-words inline-block text-left">
                            {indicator.manDesc}
                          </div>
                        </td>
                      )}

                      {isFirstOverall && (
                        <td rowSpan={rows.length} className="border-r border-gray-300 text-center px-1 py-2 bg-blue-50/10 align-middle">
                          <span className="font-bold text-gray-800 text-[15px]">
                            {mandatoryScore.toFixed(2)}
                          </span>
                        </td>
                      )}

                      {row.isFirstOfGroup && (
                        <td rowSpan={row.groupRowSpan} className="border-r border-gray-300 text-center text-gray-700 font-medium py-2 px-1.5 bg-gray-50/30 break-words">
                          {row.firstIndicator}
                        </td>
                      )}

                      <td className="border-r border-gray-300 px-2 py-2.5 text-gray-800 leading-snug break-words">
                        {row.secondIndicator}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-600 px-0.5 py-1.5 break-words text-[11px]">
                        {formatLimit(row.materialType)}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-600 px-0.5 py-1.5 font-bold break-words text-[11px]">
                        {formatLimit(row.score)}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-600 px-0.5 py-1.5 break-words text-[11px]">
                        {formatLimit(row.timesLimit)}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-600 px-0.5 py-1.5 break-words text-[11px]">
                        {formatLimit(row.scoreLimit)}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-800 px-0.5 py-1.5 break-words text-[11px]">
                        {matchedStudentItem ? matchedStudentItem.isParticipate : '-'}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-800 px-0.5 py-1.5 break-words text-[11px]">
                        {matchedStudentItem ? matchedStudentItem.count : '-'}
                      </td>
                      <td className="border-r border-gray-300 px-2 py-1.5 align-middle break-words">
                        {matchedStudentItem && matchedStudentItem.attachments ? (
                          <div className="flex flex-col space-y-1.5 my-1">
                            {matchedStudentItem.attachments.map((attachment, attachmentIndex) => {
                              const isPdf = attachment.endsWith('.pdf');
                              const isImage = attachment.endsWith('.png') || attachment.endsWith('.jpg');

                              return (
                                <span key={attachmentIndex} className="text-[#1890ff] hover:underline cursor-pointer w-full block text-[11px] flex items-start" title={attachment}>
                                  {isPdf ? (
                                    <FileText size={11} className="mr-1 shrink-0 text-red-400 mt-0.5" />
                                  ) : isImage ? (
                                    <ImageIcon size={11} className="mr-1 shrink-0 text-green-500 mt-0.5" />
                                  ) : (
                                    <FileText size={11} className="mr-1 shrink-0 text-gray-400 mt-0.5" />
                                  )}
                                  <span className="break-words leading-tight">
                                    {attachment}
                                  </span>
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-gray-400 text-center block w-full">
                            -
                          </span>
                        )}
                      </td>

                      {isFirstOverall && (
                        <td rowSpan={rows.length} className="border-r border-gray-300 text-center font-bold text-gray-800 align-middle bg-[#fcfcfc] text-[14px]">
                          {bonusScore.toFixed(2)}
                        </td>
                      )}

                      {isFirstOverall && (
                        <td rowSpan={rows.length} className="text-center font-bold text-[#1890ff] align-middle bg-blue-50/10 text-[15px]">
                          {categoryTotal.toFixed(2)}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </React.Fragment>
            );
          })}

          <tr className="bg-[#f0f2f5]">
            <td className="border-r border-gray-300 px-4 py-3 font-bold text-gray-800 text-right tracking-widest" colSpan={13}>
              综合测评指标分 小计
            </td>
            <td className="px-2 py-3 text-center font-bold text-[#1890ff] text-[16px]">
              {indicatorTotal.toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

// 负面事项扣分卡片：详情页只读展示。
function SummaryNegativeDeductionCard({ student }) {
  const deductionScore = Math.abs(Number(student.deduction || 0));

  return (
    <div>
      <div className="text-gray-500 text-[12px] mb-4 space-y-1 bg-gray-50 p-3 rounded border border-gray-100">
        <div>
          <strong className="text-gray-600">扣分说明：</strong>
        </div>
        <div>
          1. 违反国家法律法规，按照国家相关规定进行处理，当学期综合素质测评成绩记为 0分。
        </div>
        <div>
          2. 违反校纪校规等日常管理规定，视情节轻重给予 10-50分 的扣分处理。在此之外允许辅导员填写扣分描述/依据（非必选）。
        </div>
      </div>

      <div className="grid grid-cols-[160px_1fr] gap-5 text-[13px] text-gray-700">
        <div>
          <div className="text-gray-500 mb-2">
            扣分分值：
          </div>
          <div className="font-bold text-red-500 text-[18px]">
            {deductionScore !== 0 ? deductionScore.toFixed(2) : '-'}
          </div>
        </div>

        <div>
          <div className="text-gray-500 mb-2">
            扣分描述/依据：
          </div>
          <div className="text-gray-800 bg-[#fafafa] border border-gray-200 p-2 rounded min-h-[50px] whitespace-pre-wrap">
            {student.deductionDesc || '无'}
          </div>
        </div>
      </div>
    </div>
  );
}

// 将指标配置转换为明细表行，并保留一级指标合并单元格需要的行数。
function buildIndicatorRows(indicator) {
  return indicator.bonusCats.flatMap((bonusCategory) => (
    bonusCategory.items.map((item, index) => ({
      firstIndicator: bonusCategory.name,
      secondIndicator: item.name,
      materialType: item.needProof,
      score: item.itemScore,
      timesLimit: item.countLimit,
      scoreLimit: item.scoreLimit,
      isFirstOfGroup: index === 0,
      groupRowSpan: bonusCategory.items.length,
    }))
  ));
}

// 当前 mock 里通过的加分项按分类保存，这里负责将其映射到指标表中的参评记录。
function getPassedBonusData(student, catId, secondIndicator) {
  const passedItems = student.bonusDetails?.[catId] || [];
  const matchedItem = passedItems.find(item => secondIndicator.includes(item.name) || item.name.includes(secondIndicator));

  if (!matchedItem) {
    return null;
  }

  return {
    isParticipate: '是',
    count: 1,
    attachments: matchedItem.attachments || [`${matchedItem.name}.pdf`],
  };
}

function formatLimit(value) {
  return value === undefined || value === null || value === '' || value === '无'
    ? '-'
    : value;
}

// 条件筛选：下拉框
function FilterSelect({ label }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-800 shrink-0 whitespace-nowrap">
        {label}：
      </span>
      <select className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:border-[#1890ff] bg-white text-gray-500">
        <option>全部</option>
        <option>是</option>
        <option>否</option>
      </select>
    </div>
  );
}

// 条件筛选：输入框
function FilterInput({ label, placeholder = '' }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-800 shrink-0 whitespace-nowrap">
        {label}：
      </span>
      <input
        placeholder={placeholder}
        className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:border-[#1890ff]"
      />
    </div>
  );
}

// 表格工具按钮
function TableToolbar() {
  return (
    <div className="flex items-center gap-4 text-gray-700">
      <button className="hover:text-[#1890ff]" title="刷新">
        <RefreshCw size={18} />
      </button>
      <button className="hover:text-[#1890ff]" title="密度">
        <SlidersHorizontal size={18} />
      </button>
      <button className="hover:text-[#1890ff]" title="设置">
        <Settings size={18} />
      </button>
    </div>
  );
}

// 基本信息展示项
function InfoItem({ label, value }) {
  return (
    <div>
      <span className="text-gray-400 w-28 inline-block whitespace-nowrap">
        {label}：
      </span>
      <span className="text-gray-800">
        {value}
      </span>
    </div>
  );
}

// 表格表头
function TableHead({ children }) {
  return (
    <th className="py-3 px-4 font-medium text-gray-800">
      {children}
    </th>
  );
}

// 表格单元格
function TableCell({ children }) {
  return (
    <td className="py-3 px-4">
      {children}
    </td>
  );
}
